import React from 'react';
import CarCardWrapper from '../CarCard/CarCardWrapper';

interface CustomResultsProps {
  results: any[];
}

const CustomResults: React.FC<CustomResultsProps> = ({ results }) => {
  // Deduplicate by mileage + year + transmission + color fingerprint
  const seen = new Set<string>();
  const deduplicated = results.filter((result) => {
    const key = [
      result.listing_mileage_value?.raw,
      result.listing_production_year?.raw,
      result.listing_transmission_txt?.raw,
      result.listing_grouped_exterior_color?.raw,
      result.listing_ps?.raw,
    ].join('|');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 min-[2200px]:grid-cols-4 gap-6 px-1 lg:px-0">
      {deduplicated.map((result, index) => (
        <CarCardWrapper key={index} result={result} />
      ))}
    </div>
  );
};

export default CustomResults;